export default __webpack_public_path__ + "static/certificate-5k-vertical-77e08b0ad45516815e606a0858df6dd0.png";